import { render, staticRenderFns } from "./newPro.vue?vue&type=template&id=0d439ea6&scoped=true&"
import script from "./newPro.vue?vue&type=script&lang=js&"
export * from "./newPro.vue?vue&type=script&lang=js&"
import style0 from "./newPro.vue?vue&type=style&index=0&id=0d439ea6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d439ea6",
  null
  
)

export default component.exports